import React ,{Component} from 'react'; 
import { Navigate  } from 'react-router-dom';
import axios from 'axios'; 
import Table from '@mui/material/Table';
import Serverurl from './Apiurl';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import TableRow from '@mui/material/TableRow'; 
import { makeStyles } from '@mui/styles'; 
import FormControlLabel from '@mui/material/FormControlLabel';
import Paper from '@mui/material/Paper';  
import TableSortLabel from '@mui/material/TableSortLabel';
import TableBody from '@mui/material/TableBody'; 
import TableCell from '@mui/material/TableCell';  
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';  
import TablePagination from '@material-ui/core/TablePagination'; 
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import AddBoxRoundedIcon from '@mui/icons-material/AddBoxRounded';
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import pageimg from './images/attendance.png';
import Checkbox from '@mui/material/Checkbox';

const headCells = [


  
  
  { id: 'sb_title', numeric: false, label: 'Title' },
  { id: 'tc_title', numeric: false, label: 'Class' },
  { id: 'syllabustype', numeric: false, label: 'Syllabus Type' },
  { id: 'displaytype', numeric: false, label: 'Display Type' },
  { id: 'stype', numeric: false, label: 'Subject Type' },
  { id: 'sb_code', numeric: false, label: 'Subject Code' },
    { id: 'sb_sort', numeric: false, label: 'Sort order' },
  { id: '',  label: '' },
  
  ]
function stableSort(array, cmp) {
	  const stabilizedThis = array.map((el, index) => [el, index]);
	  stabilizedThis.sort((a, b) => {
		const order = cmp(a[0], b[0]);
		if (order !== 0) return order;
		return a[1] - b[1];
	  });
	  return stabilizedThis.map(el => el[0]);
}
function desc(a, b, orderBy) {
	  if (b[orderBy] < a[orderBy]) {
		return -1;
	  }
	  if (b[orderBy] > a[orderBy]) {
		return 1;
	  }
	  return 0;
}
function getSorting(order, orderBy) {
	return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}

function EnhancedTableHead(props) {
		const { classes,  order, orderBy,  rowCount, onRequestSort } = props;
		const createSortHandler = property => event => {
		onRequestSort(event, property);
		};

	  return (
		<TableHead>
		  <TableRow>
			
			{headCells.map(headCell => (
			  <TableCell
				key={headCell.id}
				align={headCell.numeric ? 'right' : 'left'}
				padding={headCell.disablePadding ? 'none' : 'default'}
				sortDirection={orderBy === headCell.id ? order : false}
			  >
				<TableSortLabel
				  active={orderBy === headCell.id}
				  direction={orderBy === headCell.id ? order : 'asc'}
				  onClick={createSortHandler(headCell.id)}
				>
				  {headCell.label}
				  {orderBy === headCell.id ? (
					<span className={useStyles.visuallyHidden}>
					  {order === 'desc' ? ' ' : ' '}
					</span>
				  ) : null}
				</TableSortLabel>
			  </TableCell>
			))}
		  </TableRow>
		</TableHead>
	  );
}


EnhancedTableHead.propTypes = {
	  classes: PropTypes.object.isRequired,
	 
	  onRequestSort: PropTypes.func.isRequired,
	 
	  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
	  orderBy: PropTypes.string.isRequired,
	  rowCount: PropTypes.number.isRequired,
};

const useStyles = makeStyles({  
  root: {  
    width: '100%',  
  },  
  container: {  
    maxHeight: 440,  
  }, 
 icon: {
   verticalalign:'middle',
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },  
});


export default class Subject extends Component {
	
    constructor(props) {
    super(props);
   
      this.state = {redirect: false,
      Subjectdata:[],sbid:'',page: 0 ,prevpage:0,totaldata:0,rowsPerPage:50,rowsPaging:[],
	 
	  order:'desc' ,orderBy:'',titles:'',syllabus:'',stype:'',classesarray:[],classes:'',displaytype:'',rolelabel:'Select Class',searchcustomer:'',
	          
      }
       this.updateDonenewParent = this.updateDonenewParent;
	   
	}
	
	updateDonenewParent = (text) => {this.componentDidMount();  }
	
	Search(){
	this.setState({  
      page: 0,
      rowsPerPage:50,
	  prevpage:0,Subjectdata:[]
    });
	
//this.componentDidMount();  
}
	
componentDidUpdate() {
	
  if(this.state.prevpage !== this.state.page) {
    this.setState({   prevpage: this.state.page});
  this.apicall(this.state.page, localStorage.getItem("page"));  
  }
}

	componentWillMount() { 
localStorage.setItem("pageactive",3)
}


	componentDidMount() {
	


	 
		
	
	
	document.title = "MM Coching Center - Subject Management";
	
	/*if(localStorage.getItem("MMCuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Login'
          })
		  }*/
	
	
	
	  localStorage.setItem("page",this.state.rowsPerPage)
  this.apicall(this.state.page,this.state.rowsPerPage);
  this.onloadclassbind();
} 


 onloadclassbind(){

    axios.get(Serverurl+'ajaxtrustandclass.php?action=getall&tc_type=2')
	
    
      .then((response) => {    
     
      this.setState({  classesarray: response.data,  });
      })   
    
      .then(data => {
        let roleFromApi = this.state.classesarray.map(classes => {
                            
          return {value: classes.tc_id, display:classes.tc_title}
        });
      
		
        this.setState({
          classesarray: [{value: '', display: 'Select Class'}].concat(roleFromApi)
        });
      })


} 


handleClickSearch=()=>{   
 
  
  this.apicall(this.state.page,this.state.rowsPerPage); 

	
} 

myChangeHandler = (event) => {
  let nam = event.target.name;
  let val = event.target.value;
  
  this.setState({[nam]: val});

  
  
 
}

apicall(page,rowsPerPage){
	 
	 axios.get(Serverurl+'ajaxsubjects.php?action=getall&sb_title='+this.state.titles+'&sb_class_id='+this.state.classes+'&sb_type='+this.state.stype+'&sb_syllabustype='+this.state.syllabus+'&StartIndex='+page+'&PageSize='+rowsPerPage)
     
	
  .then(resp => {  
		
    if(resp.data.length>0){
		
			this.setState({  
			  Subjectdata: resp.data,  
			   totaldata:parseInt(resp.data[0].count),
			   

		    });
		
			
			let copy=[50, 100, 150, 200, 250];
			
	  
	  this.setState({rowsPaging:copy});
	 
     }
	 else{
		   this.setState({Subjectdata:[],totaldata:0});
	 }
 
    });
}





handleChangePage = (event, newPage) => {  
   
    let pageval = localStorage.getItem("page");
    this.setState({  
      page: newPage,
      rowsPerPage:parseInt(pageval)
    });
   
 
    setTimeout(() =>  this.componentDidUpdate() ,500); 
  };  
  
  
   handleChangeRowsPerPage = event => {  
  
    let pageval = event.target.value;
    localStorage.setItem("page",pageval)

    setTimeout(() =>  this.componentDidUpdate() ,500);
    this.setState({  
      page: 0,
      rowsPerPage:parseInt(pageval),
	  prevpage:-1
    }); 
	
	
  }; 
  
  
  handleRequestSort = (event, property) => {
  const isAsc = this.state.orderBy === property && this.state.order === 'asc';
  

  this.setState({   orderBy: property,
    order:isAsc  ? 'desc' : 'asc'
   
  });
};


      subjectDelete(sbid){  
	
let r = window.confirm("Do you really want to Delete?");
 if(r == true){ //sign Out logic
 var formData = new FormData();
     formData.append('action','delete')
	 formData.append('sb_id',sbid)
	 	   
formData.append('userid',localStorage.getItem("MMCuserid"))	
	
	
	 axios.post(Serverurl+"ajaxsubjects.php", formData, {
        }).then(res => {
    
             this.setState({  
      prevpage: -1,
    
    });
   
 
    setTimeout(() =>  this.componentDidUpdate() ,500); 
  
    
            });
 }
      }
      Subjectaddbox(val){
        this.setState({ sbid: val });  
  
         setTimeout(() => this.refs.AddSubjectbox.handleClickOpen(),500);

      }

render() {

if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    }


  return (
  
  
  



 
  <React.Fragment>
   
<div className="containermain">
<div className="boxheading">
				  <div className="contntpad">
<h2><img src={pageimg}/>Subject Management</h2>
</div></div>
<div className="searchmaster">


  
  <ul>
  
 <li>
 <p ><TextField
            variant="outlined"
            margin="normal"
            fullWidth value={this.state.titles}
           inputProps={{tabIndex: "1",maxLength:150}}
			placeholder="Title"
            name="titles" onChange={this.myChangeHandler}
		
          /></p></li>
		
		<li>
	

	
		<p><FormControl  className="stadrp">
         
        <Select
         native  fullWidth
		 
		 
		 variant="outlined"
            margin="normal"
		  defaultValue={{ label: this.state.rolelabel, value: this.state.classes }}
          onChange={this.myChangeHandler}
          id="classes"
		   value={this.state.classes}
		  name="classes"
		
		
        >
		{this.state.classesarray.map(classes => (
            <option  
            
              value={classes.value}
            >
              {classes.display}
            </option  >
          ))}
		
        </Select></FormControl>
		
				</p></li>
				<li>	
	
	<p>
		<FormControl  className="stadrp">			   
		<Select
		variant="outlined"
		native
		value={this.state.syllabus}
		onChange={this.myChangeHandler}
		name='syllabus'
		id='syllabus'
		InputLabelProps={{
		shrink: true,
		}}
		>
		<option value={0}>Select Syllabus</option>
		<option value={1}>CBSE</option>
		<option value={2}>State</option>	<option value={3}>PUC</option>		
		</Select>
		</FormControl>
	</p>
	</li>
			<li>	
	
	<p>
		<FormControl  className="stadrp">			   
		<Select
		variant="outlined"
		native
		value={this.state.stype}
		onChange={this.myChangeHandler}
		name='stype'
		id='stype'
		InputLabelProps={{
		shrink: true,
		}}
		>
		<option value={0}>Select Type</option>
		<option value={1}>Core</option>
		<option value={2}>Optional</option>		
		<option value={3}>Not Mandatory</option>		
		</Select>
		</FormControl>
	</p>
	</li>
	<li><p>Color Indicator</p>
	 <ul className="grphcolorindication">
	  <li><span></span> #c0a2ec</li>
	   <li><span></span> #00dc85</li>
	    <li><span></span> #00c9d9</li>
		  <li><span></span> #2592fb</li>
		  <li><span></span> #fc595a</li> 
		  <li><span></span> #8b8b8b</li>
	  </ul>
	</li>
	
		<li>
		<p >
		<Button variant="contained" onClick={this.handleClickSearch} className="frmPrimarybtn" endIcon={<SearchIcon />}>
        Search
      </Button>	&nbsp; <Button variant="contained" onClick={()=>{this.Subjectaddbox(0)}} className="frmsecondarybtn" endIcon={<AddIcon />}>
        New
      </Button></p> </li>
		
		</ul>
		
		
		
		
</div>		

   


<AddSubjectbox ref="AddSubjectbox" id={this.state.sbid}  updateDonenew={this.updateDonenewParent}/>
<Paper className={useStyles.root}>


  <TableContainer className={useStyles.container}>  
                <Table stickyHeader aria-label="sticky table">  
<TableHead> 
<TableRow>
                                              
                       
						
                      </TableRow></TableHead>
					  
					   <EnhancedTableHead           
              order={this.state.order}
              orderBy={this.state.orderBy}
              
              onRequestSort={this.handleRequestSort}
              rowCount={this.state.Subjectdata.length}
            />
                      <TableBody>
                     {stableSort(this.state.Subjectdata, 
			getSorting(this.state.order,
			this.state.orderBy)).map((subject,index) => {  
           return (
 <React.Fragment>
 <TableRow key={index} >



<TableCell>{subject.sb_title}</TableCell>
<TableCell>{subject.tc_title}</TableCell>
<TableCell>{subject.syllabustype}</TableCell>
<TableCell>{subject.displaytype}</TableCell>
<TableCell>{subject.stype}</TableCell>
<TableCell>{subject.sb_code}</TableCell>
<TableCell>{subject.sb_sort}</TableCell>

<TableCell align="left">
<div className="actionbtns">



<Button variant="contained"  className="frmPrimarybtn" onClick={()=>{this.Subjectaddbox(subject.sb_id)}} endIcon={<EditIcon />}>
Edit
</Button>
 


{subject.subcnt==="0" && (
 <Button variant="contained" className="admsndisablebtn" onClick={()=>{this.subjectDelete(subject.sb_id)}} endIcon={<DeleteIcon />}>
  Delete
</Button>
 )}
 </div>
 
 </TableCell>
 </TableRow>

 </React.Fragment>	
);
					})}
					
					{this.state.totaldata===0 &&(
					
					<TableRow key={0} >
<TableCell align="center" colSpan="6">No Records</TableCell>
					</TableRow>
					) }
					
                      </TableBody>


</Table>
  </TableContainer> 
  <TablePagination  
        rowsPerPageOptions={[50, 100, 150, 200, 250]}  
        component="div"  
        count={this.state.totaldata}  
        rowsPerPage={this.state.rowsPerPage}  
        page={this.state.page}  
        onPageChange={this.handleChangePage}  
        onChangeRowsPerPage={this.handleChangeRowsPerPage}  
      />   
  </Paper>
  </div>	  

 </React.Fragment> 

 
 
  );
}
}


export  class  AddSubjectbox extends Component {

   constructor(props) {
      super(props)
	  
      this.state = {
		  
		   open:false,title:'',sb_id:0,classesarray:[],sort:0,classes:'',rolelabel:'Select Class',syllabustype:'',stype:'',displaytype:'',
      errormessage:'',erropen:false,ischecked:false,
	  }
      
  }
  
  
  
 onloadclassbind(){

    axios.get(Serverurl+'ajaxtrustandclass.php?action=getall&tc_type=2')
	
    
      .then((response) => {    
     
      this.setState({  classesarray: response.data,  });
      })   
    
      .then(data => {
        let roleFromApi = this.state.classesarray.map(classes => {
                            
          return {value: classes.tc_id, display:classes.tc_title}
        });
      
		
        this.setState({
          classesarray: [{value: '0', display: 'Select Class'}].concat(roleFromApi)
        });
      })
  
  
  }
  
  
 Subjectgetdata() {
	
  if(this.props.id!==0)
  {
	  
	   axios.get(Serverurl+'ajaxsubjects.php?action=getall&sb_id='+this.props.id)
  .then(resp => {  
		
    if(resp.data.length>0){
		let strcheck=false;
		if(resp.data[0].sb_ismandatory==="1")
		{
			strcheck=true;
		}
    this.setState({ 
     
      sb_id:resp.data[0].sb_id,
	  title: resp.data[0].sb_title,sort:resp.data[0].sb_sort,
      classes: resp.data[0].sb_class_id,
		syllabustype: resp.data[0].sb_syllabustype,
		displaytype: resp.data[0].sb_displaytype,
		stype: resp.data[0].sb_type,
		colors: resp.data[0].sb_color,  
		sbcode: resp.data[0].sb_code,ischecked:	strcheck	
    });
	
  }
  
});
	  
  }else{
	 this.setState({  
	  title:'',
	 
	 classes:'',
	 syllabustype:'',
	 sb_id:0,
	 colors:'',
	 displaytype:'',
	 stype:'',
	 sbcode:''
	 
	  }); 
 }
  
    }

   
handleClickOpen = (e) => {
 
  this.setState({open:!this.state.open,  title:'',displaytype:'',sbcode:'', sort:0,
     errormessage:'',erropen:false,ischecked:false
	  });
		this.Subjectgetdata();
		this.onloadclassbind();


};
handlesubchanges = (event) => 
{
	this.setState({ischecked: !this.state.ischecked});
};
myChangeHandler = (event) => {
	
	  const re = /^[0-9\b]+$/;
  let nam = event.target.name;
  let val = event.target.value;  
 

    if(nam==="sbcode")
  {
	this.setState({[nam]: val.toUpperCase()});  
  }
   else if(nam==="sort")
  {
	if (event.target.value === '' || re.test(event.target.value)) {
	  this.setState({[nam]: val}); 
  } 
  }
  else{
	  this.setState({[nam]: val});
  }

}

 handleErrorclose=(event)=>{
	  
	this.setState({open: false});  
  }


handleClose = (e) => {
	
	
 let title = this.state.title;
 let classes = this.state.classes;
 let syllabustype = this.state.syllabustype;
 let displaytype = this.state.displaytype;
 let stype = this.state.stype;
  let colors = this.state.colors;
 let sbcode = this.state.sbcode;
  let sort = this.state.sort;
 
 	let ischeck ="0" ;
	if(this.state.ischecked==true)
					  {
						ischeck="1";  
					  }
if(title==="")
{
	
	this.setState({errormessage:"Please Enter Title",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
	
	
}
if(sbcode==="")
{
	
	this.setState({errormessage:"Please Enter Code",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
	
	
}
if(classes==="")
{
	
	this.setState({errormessage:"Please Select Class ",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
	
	
}

if(syllabustype==="")
{
	
	this.setState({errormessage:"Please Select Syllabus Type",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
	
	
}

if(stype==="")
{
	
	this.setState({errormessage:"Please Select Subject Type",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
	
	
}
if(displaytype==="")
{
	
	this.setState({errormessage:"Please Select Display Type",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
	
	
}
if(sort==="")
{
	
	this.setState({errormessage:"Please Enter Sort Order",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
	
	
}

if(colors==="")
{
	
	this.setState({errormessage:"Please Select Color",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
	
	
}
   var formData = new FormData();
  
  
   if(this.state.sb_id==0)
	  {
		  formData.append('sb_id',0) 
		  
	  }
	  else
	  {
		  
	   formData.append('sb_id',this.state.sb_id)
		
          }
	  
	  
	  
	  
	 
        formData.append('action','insertorupdate') 
		
		formData.append('sb_title',title)
		formData.append('sb_class_id',classes)
		formData.append('sb_syllabustype',syllabustype)
		formData.append('sb_displaytype',displaytype)
		formData.append('sb_type',stype)
		formData.append('sb_color',colors)		
		formData.append('sb_code',sbcode)
		formData.append('sb_sort',sort)
		formData.append('sb_ismandatory',ischeck)
		
		formData.append('userid',localStorage.getItem("MMCuserid"))
		//formData.append('userid',localStorage.getItem("MMCuserid"))
		  
		axios.post(Serverurl+"ajaxsubjects.php", formData, {
        }).then(res => {
    
	
	
	if(res.data == -1)
{ 
	 

		this.setState({errormessage:"Title Already Exist.",erropen:true,open:true
		});
		window.scrollTo({
          top: 0
      })
		 return false;

	}
	
	
            this.props.updateDonenew();
    
        });
  
	
	this.setState({ open:false });
};

	 handleErrorclose=(event)=>{
	  
	this.setState({erropen: false});  
  } 

	


render (){

return(
<React.Fragment>





    <Dialog open={this.state.open} onClose={this.handleClose} maxWidth="md" fullWidth="true" aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title"> Subject Management</DialogTitle>
      <DialogContent>
	  
<div className="formlist">

	<p>  <Collapse in={this.state.erropen}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
               this.handleErrorclose();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          } severity="error"
        >
        {this.state.errormessage}
        </Alert>
      </Collapse></p>
						  
						  
	<ul>
<li>	
						  
	<p> <span className="validation">*</span> Title</p>
	
	<p><TextField name="title" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.title}
			 
			  ref={this.usernameInput}
			  inputProps={{tabIndex: "1",maxLength:150}} 
	   InputLabelProps={{ shrink: true }}
                          /></p>
						  </li>
						  <li>	
						  
	<p> <span className="validation">*</span> Code</p>
	
	<p><TextField name="sbcode" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.sbcode}
			 
			  ref={this.usernameInput}
			  inputProps={{tabIndex: "2",maxLength:9}} 
	   InputLabelProps={{ shrink: true }}
                          /></p>
						  </li>
		<li><p> <span className="validation">*</span> Class</p>
	

	
		<p><FormControl  className="stadrp">
         
        <Select
         native  fullWidth
		 
		 
		 variant="outlined"
            margin="normal"
		  defaultValue={{ label: this.state.rolelabel, value: this.state.classes }}
          onChange={this.myChangeHandler}
          id="classes"
		   value={this.state.classes}
		  name="classes"
		
		
        >
		{this.state.classesarray.map(classes => (
            <option  
            
              value={classes.value}
            >
              {classes.display}
            </option  >
          ))}
		
        </Select></FormControl>
		
				</p></li>
	
		<li>	  
		
 <p><span className="validation">*</span> Syallabus Type</p>
		<p><FormControl  className="stadrp">			   
		<Select
		variant="outlined"
		native
		value={this.state.syllabustype}
		onChange={this.myChangeHandler}
		name='syllabustype'
		id='syllabustype'
		InputLabelProps={{
		shrink: true,
		}}
		>
		<option value={0}>Select</option>
		<option value={1}>CBSE</option>
		<option value={2}>State</option>	<option value={3}>PUC</option>	
		</Select>
		</FormControl></p></li>
		<li>
		 <p><span className="validation">*</span> Subject Type</p>
		<p><FormControl  className="stadrp">			   
		<Select
		variant="outlined"
		native
		value={this.state.stype}
		onChange={this.myChangeHandler}
		name='stype'
		id='stype'
		InputLabelProps={{
		shrink: true,
		}}
		>
		<option value={0}>Select</option>
		<option value={1}>Core</option>
		<option value={2}>Optional</option>	
		<option value={3}>Not Mandatory</option>	
		</Select>
		</FormControl></p></li>
		<li>
		 <p><span className="validation">*</span> Display Type</p>
		<p><FormControl  className="stadrp">			   
		<Select
		variant="outlined"
		native
		value={this.state.displaytype}
		onChange={this.myChangeHandler}
		name='displaytype'
		id='displaytype'
		InputLabelProps={{
		shrink: true,
		}}
		>
		<option value={0}>Select</option>
		<option value={1}>Same Table</option>
		<option value={2}>New Table</option>		
		</Select>
		</FormControl></p></li>
		
		<li>
		<p> <span className="validation">*</span> Sort</p>
	
	<p><TextField name="sort" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.sort}
			 
			  ref={this.usernameInput}
			  inputProps={{tabIndex: "2",maxLength:4}} 
	   InputLabelProps={{ shrink: true }}
                          /></p>
		</li>
		<li>
		
			<p> <FormControlLabel
        label="Not Mandatory"
        control={ <Checkbox  checked={this.state.ischecked}  onChange={this.handlesubchanges}  inputProps={{ 'aria-label': 'controlled' }} />}
      /></p>
		</li>
		<li>
		 <p><span className="validation">*</span> Color</p>
		<p><FormControl  className="stadrp">			   
		<Select
		variant="outlined"
		native
		value={this.state.colors}
		onChange={this.myChangeHandler}
		name='colors'
		id='colors'
		InputLabelProps={{
		shrink: true,
		}}
		>
		<option value={0}>Select</option>
		<option value="#c0a2ec">#c0a2ec</option>
		<option value="#00dc85">#00dc85</option>	
		<option value="#00c9d9">#00c9d9</option>
		<option value="#2592fb">#2592fb</option>
<option value="#fc595a"> #fc595a</option><option value="#8b8b8b">#8b8b8b</option>			
		</Select>
		</FormControl></p></li>
		</ul>
       <div className="actionbtns">
<div className="cancelbtn">	  
        <Button varient="contained" onClick={this.handleClickOpen} color="secondary" >
          Cancel
        </Button></div> 
<div className="savebtn">
        <Button varient="contained" onClick={this.handleClose} color="secondary" >
          Save
        </Button>
		</div>

 <div className="clear"></div>



 </div>     
 </div> 			 
						    </DialogContent>
      
    </Dialog>
</React.Fragment>

) }
 
} 
  